import { Button, DrawerBody, DrawerFooter } from '@chakra-ui/react';
import * as _ from 'lodash';
import React, { useCallback } from 'react';

import { AthenaTableGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { AthenaSqlGenerationViewContext, FinleyAiViewContext } from './types';
import { AthenaSchemaSelector } from 'packages/athena/ui/AthenaSchemaSelector';

type FinleyAiAthenaSqlGenerationDrawerTablesViewProps = {
  onClickNext: () => void;
  viewContext: AthenaSqlGenerationViewContext;
  setViewContext: (value: React.SetStateAction<FinleyAiViewContext>) => void;
  creditFacilityId?: string;
};
export const FinleyAiAthenaSqlGenerationDrawerTablesView = ({
  onClickNext,
  viewContext,
  setViewContext,
  creditFacilityId,
}: FinleyAiAthenaSqlGenerationDrawerTablesViewProps) => {
  const onToggleTableSelect = useCallback(
    (tableInput: AthenaTableGQLType) => {
      const selectedTableNames = _.cloneDeep(viewContext.tableNames);

      const isTableSelected = selectedTableNames.some(
        (tableName) => tableInput.tableName === tableName,
      );

      const newTableNameSelections = isTableSelected
        ? selectedTableNames.filter(
            (tableName) => tableInput.tableName !== tableName,
          )
        : selectedTableNames.concat([tableInput.tableName]);

      setViewContext((prevState) => ({
        ...prevState,
        tableNames: newTableNameSelections,
      }));
    },
    [viewContext, setViewContext],
  );

  return (
    <>
      <DrawerBody>
        <AthenaSchemaSelector
          creditFacilityId={creditFacilityId}
          onToggleTableSelect={onToggleTableSelect}
          selectedTableNames={viewContext.tableNames}
          mode="relevantAthenaSqlGenerationTables"
          organizationId={viewContext.targetOrganizationId}
        />
      </DrawerBody>

      <DrawerFooter>
        <Button
          colorScheme="aurora"
          color="white"
          p="8px 24px"
          onClick={onClickNext}
        >
          Next
        </Button>
      </DrawerFooter>
    </>
  );
};
